/* Generated sample data for demo mode. Dates are shifted at load time so the latest entry is recent. */
import type { EntryType } from '@/domain/types'

export type SeedEntry = [date: string, type: EntryType, amount: number, method: string, notes: string]

export interface SeedParty {
  name: string
  status: 'active' | 'archived'
  phone?: string
  entries: SeedEntry[]
}

/** Latest date in the seed. Demo mode moves every date so this lands on yesterday. */
export const SEED_ANCHOR = '2026-10-30'

export const DEMO_PARTIES: SeedParty[] = [
  {
    name: 'Sharma Traders',
    status: 'active',
    entries: [
      ['2026-05-28', 'IN', 2500, 'Bank transfer', 'Invoice #1267 payment'],
      ['2026-05-30', 'IN', 8000, 'UPI', 'Balance cleared, invoice #1220'],
      ['2026-06-03', 'IN', 15000, 'UPI', 'Balance cleared, invoice #1159'],
      ['2026-06-10', 'IN', 4000, 'Cash', 'Advance against new order'],
      ['2026-06-18', 'OUT', 2000, 'Bank transfer', 'Credit note #1227'],
      ['2026-06-21', 'IN', 8250, 'Bank transfer', 'Part payment, invoice #1243'],
      ['2026-06-23', 'OUT', 3750, 'Bank transfer', 'Refund for return, invoice #1147'],
      ['2026-06-26', 'IN', 20500, 'Bank transfer', 'Invoice #1065 payment'],
      ['2026-07-12', 'OUT', 11000, 'UPI', 'Refund for return, invoice #1266'],
      ['2026-07-17', 'IN', 1750, 'UPI', 'Invoice #1093 payment'],
      ['2026-08-10', 'IN', 2000, 'Bank transfer', 'Invoice #1102 payment'],
      ['2026-08-19', 'IN', 2250, 'Bank transfer', 'Invoice #1094 payment'],
      ['2026-08-27', 'OUT', 12250, 'Bank transfer', 'Commission paid'],
      ['2026-09-01', 'IN', 15250, 'Bank transfer', 'Part payment, invoice #1184'],
      ['2026-09-12', 'IN', 2500, 'Cash', 'Invoice #1142 payment'],
      ['2026-09-13', 'IN', 4250, 'UPI', 'Balance cleared, invoice #1061'],
      ['2026-09-28', 'IN', 6000, 'Bank transfer', 'Part payment, invoice #1119'],
      ['2026-10-03', 'OUT', 5000, 'Cash', 'Credit note #1206'],
      ['2026-10-04', 'IN', 7500, 'Bank transfer', 'Part payment, invoice #1255'],
      ['2026-10-04', 'IN', 10250, 'UPI', 'Balance cleared, invoice #1190'],
      ['2026-10-07', 'IN', 3000, 'Cash', 'Festive order advance'],
      ['2026-10-10', 'IN', 8000, 'UPI', 'Part payment, invoice #1088'],
      ['2026-10-18', 'IN', 8000, 'Cash', 'Part payment, invoice #1120'],
      ['2026-10-23', 'IN', 2000, 'UPI', 'Balance cleared, invoice #1286'],
    ],
  },
  {
    name: 'Gupta Hardware',
    status: 'active',
    entries: [
      ['2026-05-08', 'IN', 5750, 'UPI', 'Invoice #1048 payment'],
      ['2026-05-11', 'OUT', 6000, 'Bank transfer', 'Rate difference adjustment'],
      ['2026-05-21', 'IN', 8000, 'Bank transfer', 'Festive order advance'],
      ['2026-05-22', 'IN', 25000, 'Cash', 'Advance against new order'],
      ['2026-05-22', 'IN', 8000, 'Cash', 'Part payment, invoice #1270'],
      ['2026-06-09', 'IN', 3500, 'UPI', 'Advance against new order'],
      ['2026-06-23', 'IN', 18000, 'Cheque', 'Part payment, invoice #1138'],
      ['2026-07-08', 'IN', 25500, 'Bank transfer', 'Part payment, invoice #1173'],
      ['2026-07-30', 'IN', 12250, 'Cheque', 'Balance cleared, invoice #1263'],
      ['2026-08-17', 'IN', 1000, 'UPI', 'Festive order advance'],
      ['2026-08-18', 'OUT', 4000, 'Cash', 'Rate difference adjustment'],
      ['2026-08-30', 'OUT', 1500, 'Cash', 'Transport charges reimbursed'],
      ['2026-09-27', 'OUT', 1250, 'UPI', 'Transport charges reimbursed'],
      ['2026-09-30', 'IN', 2000, 'UPI', 'Advance against new order'],
      ['2026-10-04', 'IN', 7500, 'Cash', 'Part payment, invoice #1121'],
      ['2026-10-04', 'IN', 1000, 'Card', 'Balance cleared, invoice #1068'],
      ['2026-10-08', 'IN', 7500, 'Cheque', 'Advance against new order'],
      ['2026-10-19', 'OUT', 5000, 'Cheque', 'Refund for return, invoice #1191'],
      ['2026-10-19', 'OUT', 4500, 'UPI', 'Transport charges reimbursed'],
    ],
  },
  {
    name: 'Patel Textiles',
    status: 'active',
    entries: [
      ['2026-05-08', 'IN', 6250, 'UPI', 'Advance against new order'],
      ['2026-05-20', 'OUT', 2500, 'UPI', 'Transport charges reimbursed'],
      ['2026-05-20', 'IN', 1000, 'Bank transfer', 'Part payment, invoice #1215'],
      ['2026-05-31', 'IN', 12750, 'Cash', 'Invoice #1285 payment'],
      ['2026-06-06', 'IN', 3750, 'Cheque', 'Balance cleared, invoice #1041'],
      ['2026-06-06', 'OUT', 500, 'UPI', 'Refund for return, invoice #1098'],
      ['2026-06-24', 'IN', 2500, 'UPI', 'Invoice #1136 payment'],
      ['2026-06-26', 'IN', 3000, 'Bank transfer', 'Balance cleared, invoice #1186'],
      ['2026-06-27', 'OUT', 4000, 'Bank transfer', 'Transport charges reimbursed'],
      ['2026-06-27', 'IN', 6000, 'Card', 'Advance against new order'],
      ['2026-07-03', 'OUT', 10750, 'Card', 'Rate difference adjustment'],
      ['2026-07-10', 'OUT', 12000, 'UPI', 'Refund for return, invoice #1061'],
      ['2026-08-12', 'OUT', 9000, 'UPI', 'Rate difference adjustment'],
      ['2026-08-15', 'IN', 7750, 'UPI', 'Balance cleared, invoice #1151'],
      ['2026-08-24', 'IN', 6000, 'Bank transfer', 'Part payment, invoice #1047'],
      ['2026-08-30', 'IN', 3000, 'Cash', 'Invoice #1249 payment'],
      ['2026-09-01', 'IN', 1000, 'UPI', 'Advance against new order'],
      ['2026-09-01', 'IN', 8750, 'Bank transfer', 'Balance cleared, invoice #1213'],
      ['2026-09-06', 'IN', 2500, 'Cheque', 'Balance cleared, invoice #1157'],
      ['2026-09-07', 'IN', 15000, 'Cash', 'Festive order advance'],
      ['2026-09-15', 'IN', 3250, 'Bank transfer', 'Advance against new order'],
      ['2026-09-18', 'OUT', 5000, 'Bank transfer', 'Refund for return, invoice #1184'],
      ['2026-09-19', 'IN', 8500, 'Bank transfer', 'Part payment, invoice #1233'],
      ['2026-09-21', 'IN', 25500, 'Cash', 'Advance against new order'],
      ['2026-09-24', 'IN', 15500, 'Bank transfer', 'Festive order advance'],
      ['2026-09-24', 'IN', 12250, 'Card', 'Festive order advance'],
      ['2026-09-30', 'OUT', 1750, 'UPI', 'Refund for return, invoice #1129'],
      ['2026-10-10', 'IN', 2000, 'UPI', 'Invoice #1195 payment'],
      ['2026-10-24', 'OUT', 6000, 'UPI', 'Commission paid'],
      ['2026-10-26', 'IN', 20250, 'UPI', 'Invoice #1222 payment'],
      ['2026-10-26', 'IN', 15000, 'UPI', 'Invoice #1167 payment'],
    ],
  },
  {
    name: 'Mehta & Sons',
    status: 'active',
    entries: [
      ['2026-05-22', 'OUT', 1000, 'Cash', 'Commission paid'],
      ['2026-05-23', 'OUT', 5750, 'Bank transfer', 'Transport charges reimbursed'],
      ['2026-06-07', 'OUT', 3500, 'UPI', 'Refund for return, invoice #1139'],
      ['2026-06-19', 'IN', 5000, 'UPI', 'Invoice #1089 payment'],
      ['2026-06-28', 'OUT', 11500, 'Cash', 'Transport charges reimbursed'],
      ['2026-07-15', 'OUT', 2750, 'UPI', 'Rate difference adjustment'],
      ['2026-08-04', 'IN', 8750, 'Cash', 'Part payment, invoice #1168'],
      ['2026-08-15', 'OUT', 19750, 'UPI', 'Transport charges reimbursed'],
      ['2026-08-22', 'IN', 5000, 'Bank transfer', 'Part payment, invoice #1050'],
      ['2026-08-23', 'OUT', 7250, 'Cash', 'Credit note #1072'],
      ['2026-09-08', 'OUT', 2750, 'Bank transfer', 'Credit note #1223'],
      ['2026-09-26', 'OUT', 3250, 'UPI', 'Credit note #1084'],
      ['2026-10-08', 'IN', 3750, 'Bank transfer', 'Festive order advance'],
      ['2026-10-30', 'OUT', 6500, 'UPI', 'Commission paid'],
    ],
  },
  {
    name: 'Reddy Agro Supplies',
    status: 'active',
    entries: [
      ['2026-05-06', 'IN', 4000, 'Cheque', 'Festive order advance'],
      ['2026-05-14', 'IN', 6750, 'UPI', 'Advance against new order'],
      ['2026-05-16', 'IN', 12000, 'UPI', 'Balance cleared, invoice #1208'],
      ['2026-06-07', 'OUT', 15250, 'Cash', 'Rate difference adjustment'],
      ['2026-06-09', 'OUT', 12000, 'Bank transfer', 'Refund for return, invoice #1069'],
      ['2026-06-13', 'IN', 2750, 'Bank transfer', 'Invoice #1192 payment'],
      ['2026-06-19', 'IN', 5750, 'UPI', 'Part payment, invoice #1275'],
      ['2026-06-19', 'IN', 15000, 'UPI', 'Advance against new order'],
      ['2026-07-03', 'IN', 6500, 'UPI', 'Balance cleared, invoice #1090'],
      ['2026-07-14', 'OUT', 9500, 'Cash', 'Rate difference adjustment'],
      ['2026-08-05', 'IN', 8250, 'UPI', 'Advance against new order'],
      ['2026-08-13', 'IN', 15000, 'UPI', 'Part payment, invoice #1271'],
      ['2026-08-21', 'OUT', 3500, 'Bank transfer', 'Transport charges reimbursed'],
      ['2026-08-21', 'IN', 4000, 'UPI', 'Balance cleared, invoice #1065'],
      ['2026-09-01', 'IN', 25000, 'Card', 'Festive order advance'],
      ['2026-09-11', 'IN', 8500, 'Cash', 'Balance cleared, invoice #1065'],
      ['2026-09-26', 'IN', 8500, 'Card', 'Advance against new order'],
      ['2026-09-26', 'IN', 2250, 'Bank transfer', 'Part payment, invoice #1167'],
      ['2026-10-05', 'IN', 8000, 'UPI', 'Balance cleared, invoice #1061'],
      ['2026-10-16', 'IN', 10750, 'Cash', 'Balance cleared, invoice #1051'],
      ['2026-10-20', 'IN', 4000, 'UPI', 'Festive order advance'],
      ['2026-10-30', 'IN', 6500, 'UPI', 'Invoice #1197 payment'],
    ],
  },
  {
    name: 'Kapoor Electronics',
    status: 'active',
    entries: [
      ['2026-05-06', 'IN', 6000, 'Bank transfer', 'Part payment, invoice #1066'],
      ['2026-05-24', 'IN', 8250, 'Cash', 'Advance against new order'],
      ['2026-06-08', 'OUT', 9000, 'UPI', 'Commission paid'],
      ['2026-06-12', 'IN', 7500, 'Bank transfer', 'Festive order advance'],
      ['2026-06-12', 'IN', 10000, 'UPI', 'Part payment, invoice #1234'],
      ['2026-06-27', 'IN', 15000, 'UPI', 'Advance against new order'],
      ['2026-07-03', 'IN', 5250, 'Bank transfer', 'Advance against new order'],
      ['2026-07-10', 'IN', 12250, 'UPI', 'Festive order advance'],
      ['2026-07-19', 'OUT', 500, 'UPI', 'Commission paid'],
      ['2026-07-22', 'OUT', 6000, 'UPI', 'Commission paid'],
      ['2026-07-30', 'IN', 2500, 'Cash', 'Festive order advance'],
      ['2026-08-21', 'IN', 10000, 'Bank transfer', 'Invoice #1122 payment'],
      ['2026-09-09', 'OUT', 15000, 'Cheque', 'Refund for return, invoice #1050'],
      ['2026-09-19', 'IN', 18000, 'Cheque', 'Festive order advance'],
      ['2026-09-20', 'IN', 10500, 'Bank transfer', 'Balance cleared, invoice #1215'],
      ['2026-10-10', 'IN', 2000, 'Cheque', 'Festive order advance'],
      ['2026-10-29', 'IN', 12000, 'Cash', 'Part payment, invoice #1088'],
    ],
  },
  {
    name: 'Iyer Foods',
    status: 'active',
    entries: [
      ['2026-05-25', 'IN', 12000, 'UPI', 'Balance cleared, invoice #1248'],
      ['2026-06-09', 'IN', 12750, 'UPI', 'Invoice #1272 payment'],
      ['2026-07-05', 'IN', 8000, 'UPI', 'Balance cleared, invoice #1157'],
      ['2026-07-06', 'IN', 20000, 'UPI', 'Balance cleared, invoice #1213'],
      ['2026-07-15', 'OUT', 2000, 'UPI', 'Commission paid'],
      ['2026-07-18', 'OUT', 7250, 'UPI', 'Transport charges reimbursed'],
      ['2026-07-25', 'IN', 10500, 'Cheque', 'Advance against new order'],
      ['2026-08-24', 'IN', 4250, 'UPI', 'Festive order advance'],
      ['2026-09-19', 'IN', 10500, 'UPI', 'Balance cleared, invoice #1062'],
      ['2026-09-20', 'IN', 2000, 'Cash', 'Advance against new order'],
      ['2026-09-30', 'IN', 3750, 'Bank transfer', 'Balance cleared, invoice #1244'],
    ],
  },
  {
    name: 'Bose Printing Works',
    status: 'archived',
    entries: [
      ['2025-11-12', 'OUT', 18000, 'Bank transfer', 'Print run advance'],
      ['2025-12-20', 'IN', 12000, 'UPI', 'Invoice #1011 payment'],
      ['2026-01-15', 'IN', 16000, 'Bank transfer', 'Invoice #1018 payment'],
      ['2026-02-02', 'OUT', 10000, 'Cash', 'Paper stock'],
    ],
  },
  {
    name: 'Khan Logistics',
    status: 'archived',
    entries: [
      ['2025-10-03', 'IN', 22500, 'Bank transfer', 'Freight invoice #1003'],
      ['2025-12-08', 'OUT', 12500, 'UPI', 'Fuel advance'],
      ['2026-01-22', 'IN', 9000, 'Cash', 'Return load'],
      ['2026-02-20', 'OUT', 19000, 'Bank transfer', 'Settlement'],
    ],
  },
]
